<script>
	localStorage.removeItem('HoyToKenTy');
	localStorage.removeItem('HoyToKenTo');
	window.location.href = '/';
</script>